export function formatLoyaltyDate(raw: string | null): string {
  if (!raw) return "";
  return new Date(raw).toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatLoyaltyAmount(n: number): string {
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
